module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "addimage.f941c079.png";